<rt-box variant="default no-padding" layout-vertical>
  <div class="title">
    <rt-heading variant="heading">
      {{ texts.step + ' ' + flowStep.position + ' - ' + stepKindLabel }}
    </rt-heading>
    @if (isEditable) {
      <rt-icon-button (click)="edit.emit()" iconName="edit" variant="outline"></rt-icon-button>
    }
  </div>
  <div class="list">
    @for (approval of approvalItems; track trackByUserId($index, approval)) {
      <div class="approval">
        <ng-container
          *ngTemplateOutlet="approvalTpl; context: { $implicit: approval }"
        ></ng-container>
      </div>
    }
  </div>
</rt-box>

<ng-template #approvalTpl let-approval>
  <div class="avatar-wrapper">
    @if (approval.user) {
      <rt-avatar
        [type]="approval.user.hasAvatar ? 'image' : 'initials'"
        [imageSrc]="approval.user.photoThumbUrl"
        [initials]="approval.user.initials"
        context="admin"
      ></rt-avatar>
    }
    @if (!approval.user) {
      <rt-avatar type="icon" iconName="person" size="base"></rt-avatar>
    }
  </div>
  <div class="details">
    <div class="name-role">
      @if (approval.user) {
        <span class="name">{{ approval.user.firstName + ' ' + approval.user.lastName }}</span
        ><rt-divider variant="dot"></rt-divider><span>{{ approval.user.roleName }}</span>
      }
      @if (!approval.user) {
        <span class="name">{{ texts.deletedUser }}</span>
      }
    </div>
    <div class="status">
      <ng-container
        *ngTemplateOutlet="getStatusTpl(approval); context: { $implicit: approval }"
      ></ng-container>
    </div>
  </div>
  <div class="actions">
    <ng-container
      *ngTemplateOutlet="getActionTpl(approval); context: { $implicit: approval }"
    ></ng-container>
  </div>
</ng-template>

<ng-template #sendReminderTpl let-approval>
  <span
    [rtTooltip]="approval.isRemindDisabled ? texts.reminderBlockedTooltip : null"
    [rtTooltipHasTextAlignCenter]="true"
    [rtTooltipMaxWidth]="220"
  >
    <rt-button
      [disabled]="approval.isRemindDisabled"
      (click)="approval.decisionId && sendReminder.emit(approval.decisionId)"
      variant="outline"
      >{{ texts.sendReminder }}</rt-button
    >
  </span>
</ng-template>

<ng-template #removeUser let-approval>
  @if (approval.canBeRemoved) {
    <rt-icon-button
      [rtTooltip]="texts.removeDeletedUserTooltip"
      [rtTooltipHasTextAlignCenter]="true"
      [rtTooltipMaxWidth]="220"
      (click)="removeApprover.emit(approval.userId)"
      variant="plain"
      iconName="close"
    ></rt-icon-button>
  }
</ng-template>

<ng-template #statusCanceled>
  {{ approvalStatusTexts.canceled }}
</ng-template>

<ng-template #statusNotRequested>
  {{ approvalStatusTexts.not_requested }}
</ng-template>

<ng-template #statusRequested>
  <rt-icon colorToken="colorIconPrimaryDefault" name="timer-sand"></rt-icon>
  {{ approvalStatusTexts.requested }}
</ng-template>

<ng-template #statusApproved let-approval>
  <rt-icon colorToken="colorIconSuccessDefault" name="done"></rt-icon>
  {{ approvalStatusTexts.approved }}&nbsp;
  <rt-date [time]="approval.statusChangedAt"></rt-date>
</ng-template>

<ng-template #statusRejected let-approval>
  <div layout-vertical>
    <div layout-horizontal layout-align-items-center>
      <rt-icon colorToken="colorIconCriticalDefault" name="block"></rt-icon>
      {{ approvalStatusTexts.rejected }}&nbsp;
      <rt-date [time]="approval.statusChangedAt"></rt-date>
    </div>
    <p class="rejection-reason">
      {{ approval.rejectionReason }}
    </p>
  </div>
</ng-template>

<ng-template #statusDeleted>
  @if (context === FlowStepViewContext.Dialog) {
    <rt-divider variant="dot"></rt-divider>
  }
  <rt-icon colorToken="colorIconCriticalDefault" name="error"></rt-icon>
  {{ texts.deletedUserDescription }}
</ng-template>

<ng-template #statusNoAccess>
  @if (context === FlowStepViewContext.Dialog) {
    <rt-divider variant="dot"></rt-divider>
  }
  <rt-icon colorToken="colorIconCriticalDefault" name="error"></rt-icon>
  {{ texts.noAccessDescription }}
</ng-template>
